<div [class.hover]="isHovering()">
	<div class="upload-dropzone fade-in">
		<span class="ant-upload-drag-icon">
			<i nz-icon nzType="file-add"></i>
		</span>
	</div>

	<input
		#uploadInput
		type="file"
		name="uploads"
		[id]="uploadId"
		[multiple]="multiple()"
		[accept]="accept()"
		[disabled]="false"
		(dragenter)="onDrag($event)"
		(dragleave)="onDrag($event)"
		(drop)="onDrop($event)"
		(click)="onClick($event)"
		(change)="onChange($event)"
	/>
</div>
